import { z } from 'zod';
/**
 * Единый формат ошибки для всех маршрутов `/api/v1/*`.
 * Клиент никогда не получает stack trace, upstream URL или provider credentials.
 */
export const API_ERROR_CODES = [
    'BAD_REQUEST',
    'VALIDATION_FAILED',
    'NOT_FOUND',
    'CONFLICT',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'RATE_LIMITED',
    'UPSTREAM_UNAVAILABLE',
    'UPSTREAM_TIMEOUT',
    'CATALOG_UNAVAILABLE',
    'PLAYBACK_NOT_CONFIGURED',
    'PLAYBACK_SESSION_EXPIRED',
    'PLAYBACK_SOURCE_UNAVAILABLE',
    // Состояния устройства из DEVICE_ENROLLMENT.md: клиент обязан различать
    // «устройство неизвестно», «ждёт одобрения» и «доступ отозван».
    'DEVICE_UNKNOWN',
    'DEVICE_PENDING',
    'DEVICE_BLOCKED',
    'DEVICE_REVOKED',
    'SESSION_EXPIRED',
    'NOT_IMPLEMENTED',
    'INTERNAL_ERROR',
];
export const apiErrorCodeSchema = z.enum(API_ERROR_CODES);
export const apiErrorSchema = z.object({
    error: z.object({
        code: apiErrorCodeSchema,
        /** Человекочитаемое сообщение, безопасное для показа в UI. */
        message: z.string(),
        /** Идентификатор запроса для сопоставления с логами сервера. */
        requestId: z.string(),
        /** Дополнительные безопасные поля: имя параметра, причина недоступности. */
        details: z.record(z.string(), z.unknown()).optional(),
    }),
});
export const API_ERROR_STATUS = {
    BAD_REQUEST: 400,
    VALIDATION_FAILED: 422,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    RATE_LIMITED: 429,
    UPSTREAM_UNAVAILABLE: 502,
    UPSTREAM_TIMEOUT: 504,
    CATALOG_UNAVAILABLE: 503,
    PLAYBACK_NOT_CONFIGURED: 503,
    PLAYBACK_SESSION_EXPIRED: 410,
    PLAYBACK_SOURCE_UNAVAILABLE: 503,
    DEVICE_UNKNOWN: 401,
    DEVICE_PENDING: 403,
    DEVICE_BLOCKED: 403,
    DEVICE_REVOKED: 403,
    SESSION_EXPIRED: 401,
    NOT_IMPLEMENTED: 501,
    INTERNAL_ERROR: 500,
};
//# sourceMappingURL=errors.js.map